import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import styles from './styles.module.scss'

const Wrapper = ({ children, className }) => {
  return (
    <div className={cx(styles.wrapper, className)}>
      {children}
    </div>
  )
}

Wrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ])
}

Wrapper.defaultProps = {
  className: null,
}

export default Wrapper
